module.exports = __webpack_public_path__ + "09f626a756ad63482925237b15dc12c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/dom.jpg
// module id = 44
// module chunks = 0